import SearchHeaderTable from './SearchHeaderTable';

export default SearchHeaderTable;
